import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import GridStructure from './GridStructure';
import { tableGridLabelsMapping } from '../../Utils/helper';
import { vahanDataList } from '../../constants/externalInformationData';
import { Fragment } from 'react';

function Vahan({ content }) {
    return (
        (content && Object?.keys(content)?.length)
            ?
            <Fragment>
                <Box>
                    <GridStructure gridDataList={vahanDataList} content={content} tab={"vahan"} />
                </Box>
                <Box>
                    {
                        vahanDataList[3]?.map((item, index) => {
                            let contentItem = "";
                            if (item === "isCommercial") contentItem = content?.[item] ? "True" : "False";
                            else if (item === "presentPincode") contentItem = content?.splitPresentAddress?.pincode;
                            else if (item === "permanentPincode") contentItem = content?.splitPermanentAddress?.pincode;
                            else contentItem = content?.[item];
                            return (
                                <Grid container key={`address${index}`} sx={{ fontFamily: "inter", lineHeight: "25px" }}>
                                    <Grid item md={1.63} sx={{ fontSize: "11px" }}>
                                        {`${tableGridLabelsMapping?.[item]}:`}
                                    </Grid>
                                    <Grid item md={10.37} sx={{ fontSize: "12px", fontWeight: "600", color: "#3A3A3A", textTransform: "uppercase" }}>
                                        {contentItem || "-"}
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Box>
            </Fragment>
            :
            <div
                style={{
                    margin: "20px 7px",
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "grey",
                }}
            >
                <h3>No data</h3>
            </div>
    )
}

export default Vahan